import { z } from 'zod';

/** Contract state of a module for one organization (docs/decisions/0012-entitlement-vs-activation.md). */
export const ENTITLEMENT_STATUSES = ['included', 'trial', 'none'] as const;
export const entitlementStatusSchema = z.enum(ENTITLEMENT_STATUSES);
export type EntitlementStatus = z.infer<typeof entitlementStatusSchema>;

export const ORGANIZATION_STATUSES = ['trial', 'active', 'suspended', 'archived'] as const;
export const organizationStatusSchema = z.enum(ORGANIZATION_STATUSES);
export type OrganizationStatus = z.infer<typeof organizationStatusSchema>;

export const ORGANIZATION_KINDS = ['civil_protection', 'private_company'] as const;
export const organizationKindSchema = z.enum(ORGANIZATION_KINDS);
export type OrganizationKind = z.infer<typeof organizationKindSchema>;

export const PLAN_KEYS = ['base', 'operational', 'complete', 'unlimited'] as const;
export const planKeySchema = z.enum(PLAN_KEYS);
export type PlanKey = z.infer<typeof planKeySchema>;

/** Per-organization limits; `null` = unlimited. */
export const organizationLimitsSchema = z.object({
  maxUsers: z.number().int().positive().nullable(),
  maxActiveMissions: z.number().int().positive().nullable(),
  maxDevices: z.number().int().positive().nullable(),
  storageMb: z.number().int().positive().nullable(),
});
export type OrganizationLimits = z.infer<typeof organizationLimitsSchema>;
